
import { defineAsyncComponent, defineComponent } from 'vue';

/** Utils */
import { listTypeslogin, listCountrys } from '@/utils/auth.utils';
import { showSwalInfo, showSwalError } from '@/utils/sweetalert2-utils';
import { showErrors } from '@/utils/general-utils';
import Swal from 'sweetalert2';

/** Interfaces */
import { LoginI, SendSmsI } from '@/interfaces/auth.interface';

/** reCAPTCHA */
import { renderReCaptchaWidget } from '@artifact-project/recaptcha';

/** Components */
import CookieConsent from '@/components/layout/CookieConsent.vue';
import { Field, Form } from 'vee-validate';

/** Validations */
import { schemaLoginForm } from '@/validations/login-validation';

export default defineComponent({
  name: 'Terminos y Condiciones',
  props: {
    token: {
      type: String,
      required: false,
      default: '',
    },
  }
  
});
